import vueI18n from '@/i18n/locale'

const SslItemManageEntry = () =>
  import(/* webpackChunkName: 'ssl-item-manage' */ '@/pages/item-manage/pages/ssl')
const PriceEdit = () =>
  import(/* webpackChunkName: 'ssl-price-edit' */ '@/pages/item-manage/pages/ssl/price-edit')

export default [
  {
    path: '/item-manage/ssl',
    name: 'SslItemManageEntry', // ssl 菜品管理相关页面
    component: SslItemManageEntry,
    children: [
      {
        path: 'price-edit',
        name: 'PriceEdit',
        component: PriceEdit,
        meta: {
          title: vueI18n.t('FoodB_edit_OzpO_pQjy'), // 编辑商品
        },
      },
    ],
  },
]
